import { User } from "@/types";
import {formatUserName, ImgSrc} from "@/utils";
import { Avatar, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { sanitizeFieldRestProps, useRecordContext } from "react-admin";
import { UserNameCellProps } from "./user-name-cell.types";

const UserNameCell: FC<UserNameCellProps> = ({ ...props }) => {
  const user = useRecordContext<User>();

  if (!user) return null;

  return (
    <Stack
      direction={"row"}
      spacing={2}
      sx={{ cursor: "pointer" }}
      alignItems={"center"}
      {...sanitizeFieldRestProps(props)}
    >
      <Avatar
        alt="avatar"
        src={ImgSrc(user.profileImage?.path ?? "", 64, true)}
        sx={{ height: 32, width: 32 }}
      />
      <Typography component="span" variant="body2" noWrap={true}>
        {formatUserName(user?.firstName, user?.lastName, user.status)}
      </Typography>
    </Stack>
  );
};

export { UserNameCell };
